'use client'

import { useCallback, useState } from 'react'
import { useUpdatePatientDataReuseConsentMutation } from '@/core/graphql/hooks'

export function useDataReuseConsent(consultationId: string) {
  const [consentCompleted, setConsentCompleted] = useState(false)
  const [updateDataReuseConsent] = useUpdatePatientDataReuseConsentMutation()

  const handleConsentComplete = useCallback(
    (accepted: boolean) => {
      updateDataReuseConsent({
        variables: {
          payload: {
            consultationId,
            dataReuseConsent: accepted,
          },
        },
      })
      setConsentCompleted(true)
    },
    [consultationId, updateDataReuseConsent],
  )

  return { consentCompleted, handleConsentComplete }
}
